import { useContext, useEffect, useState } from "react";

import ChildCard from "@src/components/shared-layouts/ChildCard";
import LocationContext from "@context/location/locationContext";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";

import { getSummaryData, summaryInitialState } from "./helper";
import { SummaryMainWrapper } from "./style";
import SummaryContent from "./SummaryContent";

const Summary = () => {
  const [{ locationState }] = useContext(LocationContext);
  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);
  const { property, store, revenueCenter, date } = locationState;
  const [summaryData, setSummaryData] =
    useState<NotificationSummaryDataType>(summaryInitialState);
  const [loading, setLoading] = useState(true);
  const [lastUpdatedTime, setLastUpdatedTime] = useState<string>("");

  const getData = async (filters: FilterType) => {
    const res = await getSummaryData(filters);
    if (!res.error) {
      setSummaryData(res?.data);
      setLastUpdatedTime(res?.data?.last_updated);
    } else {
      showErrorToastSetState({
        errorMessage: res.error || "",
        errorTitle: "Unable to Fetch Notification Summary",
        open: true,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    const filter: FilterType = {
      property,
      store,
      rvc: revenueCenter,
      date,
    };
    getData(filter);
  }, [property, store, revenueCenter, date]);

  return (
    <SummaryMainWrapper>
      <ChildCard title="Total Summary">
        <SummaryContent
          loading={loading}
          summaryData={summaryData}
          lastUpdatedTime={lastUpdatedTime}
        />
      </ChildCard>
    </SummaryMainWrapper>
  );
};

export default Summary;
